export const dateComparators = {
    equal: '=',
    lessThanEqual: '<=',
    moreThanEqual: '>=',
    less: '<',
    more: '>',
    between: 'Entre',
} as const;

export type DateComparatorsType = (typeof dateComparators)[keyof typeof dateComparators];
